exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-submenu__icon-arrow{color:#fff !important}.scrollbar-wrapper{padding-bottom:20px}", ""]);

// exports
